import {safelyParsePage} from "@rw/string_utils";
import {isEqual} from "lodash";
import {Dispatch} from "redux";

import {appPath} from "../../../../../../packages/utils/cars_routes";
import {fetchCarDetailsToEditAtRoute} from "../../../dashboard/edit_car/actions/fetch_car_details_to_edit_at_route";
import {fetchMakesDataForSearch} from "../../../homepage/actions/fetch_makes_data_for_search";
import {updateHomepageMetaData} from "../../../homepage/actions/update_homepage_meta_data";
import {ICarListOfferResponse} from "../../../meta_data/reducers/meta_data_reducer";
import {setCarDetailViewTypeAtRoute} from "../../../offer/action/offer_view_type_action";
import {fetchCarsDetailsAtRoute} from "../../../offer/detail/actions/fetch_cars_details_at_route";
import {fetchCarsDetailsAWSGallery} from "../../../offer/detail/actions/fetch_cars_details_AWS_Gallery";
import {updateOfferMetaData} from "../../../offer/detail/actions/update_offer_meta_data";
import {fetchLatestCarListAtRoute} from "../../../offer/list/actions/fetch_latest_cars_list";
import {fetchAndValidateLocationBySlugAtRoute, ILocation} from "../../../offer/list/actions/fetch_location_by_slug_at_route";
import {fetchCarListLocationsAtRoute} from "../../../offer/list/actions/fetch_location_car_list_data_at_route";
import {fetchLocationsPlData} from "../../../offer/list/actions/fetch_Locations_Pl_Data";
import {ISearchResultRouteParams, redirectConstraintsAtRoute} from "../../../offer/list/actions/redirect_constraints";
import {setViewModeForOfferDetail} from "../../../offer/list/actions/set_view_mode_for_offer_detail";
import {updateCarListMetaData} from "../../../offer/list/actions/updateCarsListMetaData";
import {getParamsByTag, IOfferListFetchParams} from "../../../offer/list/url_utils/tag_utils";
import {parseOfferListPath} from "../../../offer/list/url_utils/parse_offer_list_path";
import {makeSlugToApiType} from "../../../offer/utils/make_slug_to_api_type";
import {slimOfferForCardList} from "../../../offer/utils/get_offer_card_image";
import {updateContactPageMetaData} from "../../../pages/contact/actions/update_contactpage_meta_data";
import {fetchSellerOffersAtRoute} from "../../../seller/actions/fetch_seller_offers_at_route";
import {updateSellerMetaData} from "../../../seller/actions/update_seller_meta_data";
import {IStore} from "../../reducers/hybrid_reducer";
import {IServices} from "../../services/IServices";
import {appendQueryString} from "../../utils/append_query_string";
import {createRequestActionTypes} from "../../utils/request_response_utils/factories/create_request_action_types";
import {getRequest} from "../../utils/request_response_utils/request";
import {apiLink} from "../api_link";
import {mapActions, reduceActions, strictMapActions} from "./action_helpers";
import {createAppPathDataFetcher, IRouteFetch, IRouteState} from "./create_app_path_data_fetcher";

export const fetchCarListTypes = createRequestActionTypes({name: "fetch", type: "GET", view: "car_list"});

export interface ICarsResponse {
    results: ICarListOfferResponse[];
}
export interface IOfferListApiResponse<T> {
    data: T[];
    page: number;
    totalPages: number;
    totalItems: number;
    currentPage: number;
}
export interface IOfferListResponseSSR<T> extends IOfferListApiResponse<T> {
    pageCount: number;
    page: number;
    totalPages: number;
    totalItems: number;
    currentPage: number;
}

//TODO : to move from here  searchFormFields, FormValuesType, IRouteData,, getOfferListFetchParams
export enum FormFieldType {
    // deprecated component-based FormFieldTypes
    Checkbox = "checkbox",
    Input = "input",
    InputRange = "input-range",
    Radio = "radio",
    Select = "select",
    SelectRange = "select-range",
    Textarea = "textarea",
    SelectRangeNumber = "select-range-number",
    PhoneField = "phone-field",
    FeatureList = "feature-list"
}

export const searchFormFields = {
    search: FormFieldType.Input
    // offer_type: FormFieldType.SearchOfferType,
    // deal_type: FormFieldType.Select,
};

export type FormValuesType = Record<keyof typeof searchFormFields, any>;

interface IRouteData {
    state?: {searchFormValues?: FormValuesType};
    query: Record<string, string | string[]>;
    params: ISearchResultRouteParams;
}
export const defaultOffersParams = {
    offer_type: "osobowe",
    page: "1",
    per_page: 21,
    is_active: true
};
export function urlParamsValidator(params: Partial<any>, additionalKeys: string[] = []): Partial<any> {
    const keys = [
        "price__gte",
        "price__lte",
        "millage__gte",
        "millage__lte",
        "yearFrom",
        "yearTo",
        "gearbox",
        "sort",
        "size__gte",
        "size__lte",
        ...additionalKeys
    ];

    return keys.reduce((acc, curr) => {
        const value = params[curr];
        if (value) {
            return {
                ...acc,
                [`${curr}`]: value
            };
        }
        return acc;
    }, {});
}
//TODO to be moved getOfferListFetchParams
export const getCarsOfferListFetchParams = (routeData: IRouteData, location: ILocation | null, search_form_offer_type?: string): IOfferListFetchParams => {
    const parsed = parseOfferListPath(routeData.params as ISearchResultRouteParams);
    const {model: queryModel, ...queryWithoutModel} = routeData.query || {};
    const modelFromQuery = Array.isArray(queryModel) ? queryModel[0] : queryModel;
    const model = parsed.model || (typeof modelFromQuery === "string" ? modelFromQuery : undefined);
    // Keep URL slug in latestQuery / form (alfaromeo); map to API label only when requesting.
    const type = parsed.type || routeData.params.type;

    const paramsFromTag = getParamsByTag(routeData.params.offerType, routeData.params.tag);

    return {
        ...defaultOffersParams,
        ...queryWithoutModel,
        type,
        ...(model ? {model} : {}),
        ...urlParamsValidator(queryWithoutModel, ["name", "geo_point"]),
        ...paramsFromTag,
        ...(location && location.slug ? {location: location.slug} : {})
    };
};

export const fetchOfferListWithUniqueParams =
    (services: Partial<IServices>, params: IOfferListFetchParams, onSuccess?: (offersResponse: ICarListOfferResponse[]) => void) =>
    (dispatch: Dispatch, getState: () => IStore): Promise<void | null | IOfferListResponseSSR<ICarListOfferResponse>> => {
        // guard against refetching with the same query
        const {latestQuery} = getState().carList;
        // ignore `mapView` param that is used to determine if map view is active, we don't want to trigger fetches because it changed
        const {...validParams} = params;
        //  console.log("validParams", validParams);
        if (isEqual(validParams, latestQuery)) {
            return Promise.resolve(null);
        }
        return dispatch(fetchCarList(services, params, onSuccess));
    };

export const fetchCarListAtRoute =
    (services: Partial<IServices>, route: IRouteState<ISearchResultRouteParams>) => async (dispatch: Dispatch, getState: () => IStore) => {
        //const location = getState().carList.location.location?.slug;
        const location = getState().carList.location.location;
        const params = getCarsOfferListFetchParams(route, location);

        const parsedPage = params.page ? safelyParsePage(params.page) : 1;

        const result = await dispatch(fetchOfferListWithUniqueParams(services, params));
        if (result && result.pageCount < parsedPage && parsedPage > 1) {
            const {page, ...queryWithoutPage} = route.query;
            const firstPageUrl = appendQueryString(route.pathname, queryWithoutPage);
            //  dispatch(enable301ResponseState(firstPageUrl));
            return null;
        }
        return result;
    };

//fetchCarListAtRoute
const fetchCarList =
    (services: Partial<IServices>, params: IOfferListFetchParams, onSuccess?: (offersResponse: ICarListOfferResponse[]) => void) =>
    (dispatch: Dispatch, getState: () => IStore) => {
        dispatch({type: fetchCarListTypes.start, latestQuery: params});
        // console.log("params", params);

        const apiType = makeSlugToApiType(params.type as string) || params.type;
        const url = appendQueryString(apiLink.cars.base({})(null), {...params, type: apiType, location: params.location, ss: "aB2a"});
        return getRequest(services, url, "fetchCarList")
            .then((response: IOfferListApiResponse<ICarListOfferResponse>) => {
                if (response) {
                    const slimData = (response.data || []).map((car) => slimOfferForCardList(car));
                    const result: IOfferListResponseSSR<ICarListOfferResponse> = {
                        // meta: response.meta || fallbackMeta,
                        data: slimData,
                        pageCount: response.totalPages,
                        totalPages: response.totalPages,
                        totalItems: response.totalItems,
                        currentPage: response.currentPage,
                        page: (params.page && safelyParsePage(params.page)) || 1
                    };
                    dispatch({type: fetchCarListTypes.success, result: result});
                    return result;
                }
            })
            .catch((err) => {
                console.log("Error", err);
                return null;
            });
    };

const FETCH_ROUTES: IRouteFetch<IStore>[] = [
    {
        path: appPath.mainPage,
        exact: false,
        // matches all routes, triggers additional asynchronous promise chain
        // fetch: reduceActions(() => {
        //     console.log("fetcher");
        //     // Zwracanie funkcji, która zwraca pustą obietnicę
        //     return (dispatch, getState) => {
        //         return new Promise((resolve, reject) => {
        //             // Tutaj można dodać kod asynchroniczny, jeśli potrzebny
        //             // resolve();
        //         });
        //     };
        // }),
        routes: [
            {
                path: appPath.mainPage,
                fetch: mapActions(
                    fetchMakesDataForSearch,
                    fetchCarListLocationsAtRoute,
                    updateHomepageMetaData,
                    fetchLatestCarListAtRoute
                )
                //fetch: mapActions(setHomepageViewTypeAtRoute, updateHomepageMetaData)
            },
            {
                path: appPath.offer.detail.base,
                fetch: reduceActions(
                    //     // validateOfferDetailFetchAtRoute,
                    //     // openOfferModalAtRoute,
                    strictMapActions(fetchCarsDetailsAtRoute),
                    fetchCarsDetailsAWSGallery,
                    updateOfferMetaData,
                    setCarDetailViewTypeAtRoute
                )
            },
            {
                path: appPath.seller.detail,
                fetch: reduceActions(strictMapActions(fetchSellerOffersAtRoute), updateSellerMetaData)
            },
            {
                path: appPath.admin.userDashboard.edit,
                fetch: reduceActions(
                    //     // openOfferModalAtRoute,
                    strictMapActions(fetchCarDetailsToEditAtRoute)
                    //     // updateOfferMetaData,
                    //setCarDetailViewTypeAtRoute
                )
            },
            {
                path: [appPath.searchResult.universalTag, appPath.searchResult.universal],
                fetch: reduceActions(
                    /*TODO fetching cars data by location ?? */
                    redirectConstraintsAtRoute,
                    fetchAndValidateLocationBySlugAtRoute,
                    strictMapActions(
                        fetchCarListAtRoute,
                        fetchCarListLocationsAtRoute,
                        fetchMakesDataForSearch,
                        fetchLocationsPlData
                        //     resetClientOnlySearchFormAtRoute
                    ),
                    updateCarListMetaData,
                    // setOfferListViewTypeAtRoute,
                    setViewModeForOfferDetail
                ),
                exact: true
            },
            {
                path: appPath.contact,
                fetch: mapActions(updateContactPageMetaData)
            }
        ]
    }
];

export const appPathDataFetcher = createAppPathDataFetcher<IStore>(FETCH_ROUTES);
